import { createRouter, createWebHashHistory } from 'vue-router'
import { store } from 'xijs';
import { pageConstant } from '@/config/contant.js'

const routes = [
    {
        path: '/',
        redirect: '/login',
        children: [{
            name: 'login',
            path: '/login',
            meta: {
                title: '登录'
            },
            component: () => import('@/views/other/login.vue'),
        }]
    },
    {
        path: '/home',
        component: () => import('@/views/home.vue'),
        name: 'home',
        meta: {
            title: '首页'
        },
    },
    {
        name: 'fangkeyuyue',
        path: '/fangkeyuyue',
        meta: {
            title: '访客预约'
        },
        component: () => import('@/views/other/fangkeyuyue.vue'),
    },
    {
        name: 'communityInfo',
        path: '/communityInfo',
        meta: {
            title: '小区信息'
        },
        component: () => import('@/views/houseCommunity/communityInfo.vue'),
    },
    {
        name: 'zhouBianPeiTao',
        path: '/zhouBianPeiTao',
        meta: {
            title: '周边配套'
        },
        component: () => import('@/views/houseCommunity/zhouBianPeiTao.vue'),
    },
    {
        name: 'gongGongSheShi',
        path: '/gongGongSheShi',
        meta: {
            title: '公共设施'
        },
        component: () => import('@/views/houseCommunity/gongGongSheShi.vue'),
    },
    {
        name: 'communityQuanJing',
        path: '/communityQuanJing',
        meta: {
            title: '小区全景'
        },
        component: () => import('@/views/houseCommunity/communityQuanJing.vue'),
    },
    {
        name: 'myApartmentType',
        path: '/myApartmentType',
        meta: {
            title: '我的户型'
        },
        component: () => import('@/views/digitalDeliveryHouse/myApartmentType.vue'),
    },
    {
        name: 'houseInfo',
        path: '/houseInfo',
        meta: {
            title: '房屋信息'
        },
        component: () => import('@/views/digitalDeliveryHouse/houseInfo.vue'),
    },
    {
        name: 'houseHeTong',
        path: '/houseHeTong',
        meta: {
            title: '房屋合同'
        },
        component: () => import('@/views/digitalDeliveryHouse/houseHeTong.vue'),
    },
    {
        name: 'bimTuZhi',
        path: '/bimTuZhi',
        meta: {
            title: 'BIM图纸'
        },
        component: () => import('@/views/digitalDeliveryHouse/bimTuZhi.vue'),
    },
    {
        name: 'jiaoFuYangBan',
        path: '/jiaoFuYangBan',
        meta: {
            title: '交付样板'
        },
        component: () => import('@/views/digitalDeliveryHouse/jiaoFuYangBan.vue'),
    },
    {
        name: 'fireSafe',
        path: '/fireSafe',
        meta: {
            title: '消防安全'
        },
        component: () => import('@/views/digitalDeliveryHouse/fireSafe.vue'),
    },
    {
        name: 'AIchat',
        path: '/AIchat',
        meta: {
            title: 'AI问答'
        },
        component: () => import('@/views/digitalDeliveryHouse/AIchat.vue'),
    },
    {
        name: 'kongQiJianCe',
        path: '/kongQiJianCe',
        meta: {
            title: '空气监测'
        },
        component: () => import('@/views/digitalDeliveryHouse/kongQiJianCe.vue'),
    },
    {
        name: 'louPanZiXun',
        path: '/louPanZiXun',
        meta: {
            title: '楼盘资讯'
        },
        component: () => import('@/views/digitalDeliveryHouse/louPanZiXun.vue'),
    },
    {
        name: 'jingZhuangYangBan',
        path: '/jingZhuangYangBan',
        meta: {
            title: '精装样板'
        },
        component: () => import('@/views/digitalViewHouse/jingZhuangYangBan.vue'),
    },
    {
        name: 'apartmentType',
        path: '/apartmentType',
        meta: {
            title: '小区户型'
        },
        component: () => import('@/views/digitalViewHouse/apartmentType.vue'),
    },
    {
        name: 'kanFangYuYue',
        path: '/kanFangYuYue',
        meta: {
            title: '看房预约'
        },
        component: () => import('@/views/digitalViewHouse/kanFangYuYue.vue'),
    },
    {
        name: 'wenJuanDiaoCha',
        path: '/wenJuanDiaoCha',
        meta: {
            title: '问卷调查'
        },
        component: () => import('@/views/digitalViewHouse/wenJuanDiaoCha.vue'),
    },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    const app = document.getElementById('app')
    if (app) {
      app.scrollTo(0, 0)
    }

    return { x: 0, y: 0 }
  }
})

// 记录最近一次视口尺寸变化的时间，用于拦截 DevTools 切 H5 模式时从 home 误触发的路由跳转
let lastViewportChangeTime = 0
window.addEventListener('resize', () => {
    console.log('[全局事件] 视口尺寸变化，更新 lastViewportChangeTime')
    lastViewportChangeTime = Date.now()
})

// 导航守卫
router.beforeEach((to, from, next) => {
    console.log('[路由守卫] from:', from.fullPath, '→ to:', to.fullPath, '| 距离上次 resize:', Date.now() - lastViewportChangeTime, 'ms')

    // 拦截：1000ms 内从 home 页面跳走的请求，且期间发生了视口尺寸变化（DevTools 切 H5 模拟的 点击 误触）
    if (from.path === '/home'
        && to.path !== '/home'
        && Date.now() - lastViewportChangeTime < 1000) {
        console.log('[路由守卫] 拦截 home 页面误触跳转')
        next(false)
        return
    }

    if (store.get(pageConstant.storageSyncUserKey).status == 0) {
        // 已登录且要跳转的页面是登录页
        if (to.path === '/login') {
            next({ path: '/home' })
        } else {
            next()
        }
    } else {
        if (to.path === '/login') {
            next()
        } else {
            // 否则全部重定向到登录页
            next('/login')
        }
    }
})

export default router
